import { Fieldset } from "primereact/fieldset";
import React, { useEffect, useState } from "react";
import { API_GET_APP_INFO } from "../../api/company.service";
import { useParams } from "react-router-dom";

const AppInfo = () => {
  const { companyId } = useParams();
  const [company, setCompany] = useState({});

  useEffect(() => {
    const fetchAppinfo = async () => {
      try {
        const response = await API_GET_APP_INFO(companyId);
        setCompany(response?.app || {});
      } catch (error) {
        console.error("Failed to fetch app info:", error);
      }
    };

    if (companyId) {
      fetchAppinfo();
    }
  }, [companyId]);

  return (
    <div className="p-4">
      <Fieldset legend="App Info Details">
        {/* Full Border Wrapper */}
        <div className="border border-gray-300 rounded-md bg-white p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-sm text-gray-700">
            <Detail label="Name" value={company.name} />
            <Detail label="Business ID" value={company.businessId} />
            <Detail label="Phone" value={`+${company.phone}`} />
            <Detail label="Phone ID" value={company.phoneId} />
            <Detail label="Language Code" value={company.languageCode} />
            <Detail label="Provider" value={company.provider} />
            <Detail label="Namespace" value={company.namespace} />
            <Detail label="Live" value={company.live ? "Yes" : "No"} />
            <Detail label="Version" value={company.version} />
            <Detail label="Type" value={company.type} />
            <Detail label="Federated" value={company.federated ? "Yes" : "No"} />
            <Detail
              label="Template Messaging"
              value={company.templateMessaging ? "Enabled" : "Disabled"}
            />
            <Detail
              label="Embed Allowed"
              value={company.embedAllowed ? "Yes" : "No"}
            />
            <Detail
              label="Opt-in URL Disabled"
              value={company.disableOptinPrefUrl ? "Yes" : "No"}
            />
            <Detail label="Storage Region" value={company.storageRegion} />
            <Detail
              label="New Billing Enabled"
              value={company.newBillingEnabled ? "Yes" : "No"}
            />
            <Detail label="Stopped" value={company.stopped ? "Yes" : "No"} />
            <Detail label="Created On" value={formatDate(company.createdOn)} />
            <Detail label="Modified On" value={formatDate(company.modifiedOn)} />
            <Detail label="Live Timestamp" value={formatDate(company.liveTs)} />
          </div>
        </div>
      </Fieldset>
    </div>
  );
};

const Detail = ({ label, value }) => (
  <div>
    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
      {label}
    </p>
    <p className="mt-1 text-gray-800">{value || "—"}</p>
  </div>
);

const formatDate = (timestamp) => {
  if (!timestamp) return "—";
  const date = new Date(timestamp);
  return date.toLocaleString();
};

export default AppInfo;
